import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { ScheduleComponent } from './schedule/schedule.component';
import { ScheduleListComponent } from './schedule-list/schedule-list.component';
import { ScheduleEditComponent } from './schedule-edit/schedule-edit.component';

import { ScheduleRoutingModule } from './schedule-routing.module';

import { ScheduleService } from './schedule.service';
import { SharedModule } from '../../shared/shared.module';

//Spinner
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxSpinnerService } from 'ngx-spinner';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    ScheduleRoutingModule,
    SharedModule,
    NgxSpinnerModule
  ],
  declarations: [
    ScheduleComponent,
    ScheduleListComponent,
    ScheduleEditComponent
  ],
  providers: [
    ScheduleService,
    NgxSpinnerService
  ]
})
export class ScheduleModule { }



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/schedule/schedule.module.ts